import { createContext, useContext } from 'react'

export const DashboardLayoutContext = createContext({
  onMobileNavOpen: () => {},
})

export const useDashboardLayout = () => useContext(DashboardLayoutContext)
